module.exports = __webpack_public_path__ + "static/10-82097cb5f8f6d7d0e33eefd70dab908c.jpg";